
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { range } from 'lodash'
import { NextSeo } from 'next-seo'
import useTranslation from 'next-translate/useTranslation'
import { UrlObject } from 'url'
import CarFormProgress from '@/domains/car/components/CarForm/CarFormProgress'
import CarFormStep from '@/domains/car/components/CarForm/CarFormStep'
import Option from '@/domains/car/components/CarForm/Option'
import {
  MIN_SELECTABLE_REGISTRATION_YEAR,
  RegistrationYear,
  useParseModel,
  useRedirectOnParseError,
} from '@/domains/car/helpers/parseCarFormQuery'
import { createGetServerSideProps } from '@/helpers/createGetServerSideProps'
import { useSearchParams } from '@/helpers/useSearchParams'

export default function CarFormRegistrationYearStep() {
  const { t } = useTranslation('carPawnFormRegistrationYearStep')
  const queryParams = useSearchParams()

  const parseModelResult = useParseModel()

  useRedirectOnParseError(parseModelResult)

  function getUrl(year: RegistrationYear): UrlObject {
    return {
      pathname: '/autopfand-formular/kontaktdaten',
      query: {
        ...queryParams,
        zulassungsjahr: year,
      },
    }
  }

  return (
    <CarFormStep step={3}>
      <NextSeo noindex nofollow title={t('title')} />

      <div>
        <CarFormProgress step={3} />

        <h1 className="text-heading-m text-primary text-center my-2">
          {t('initial_registration_question')}
        </h1>
      </div>

      <div className="flex flex-row flex-wrap gap-2">
        {range(
          new Date().getFullYear(),
          MIN_SELECTABLE_REGISTRATION_YEAR - 1,
        ).map((year) => (
          <Option
            href={getUrl(year)}
            key={year}
            className="flex-1 basis-1/3 justify-center"
          >
            {year}
          </Option>
        ))}

        <Option
          href={getUrl('before-range')}
          className="flex-1 basis-full justify-center"
        >
          {t('carPawnForm:before_year', {
            year: MIN_SELECTABLE_REGISTRATION_YEAR,
          })}
        </Option>
      </div>
    </CarFormStep>
  )
}

 const _getServerSideProps = createGetServerSideProps()


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/autopfand-formular/zulassungsjahr',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  